import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 20v-10l10 6v-12","key":"svg-0"}],["path",{"d":"M13 7l3 -3l3 3","key":"svg-1"}]]

const IconArrowZigZag = createReactComponent('outline', 'arrow-zig-zag', 'ArrowZigZag', __iconNode);

export default IconArrowZigZag;